import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Loading,
  EmptyState,
  Flex,
  FlexItem,
  SpacingVertical,
  SPACING_24
} from 'mailup-web-components'
import Header from './components/Header'
import Footer from './components/Footer'
import CheckReputation from './components/CheckReputation/CheckReputation'
import CheckReachability from './components/CheckReachability'
import LinkSection from './components/LinkSection/LinkSection'
import PageContainer from 'Components/PageContainer'

import { pageState } from 'Pages/MessageCheckupLinkCheck/recoil/state/page'
import {
  linkcheckSummaryBoxState,
  messageState
} from 'Pages/MessageCheckupLinkCheck/recoil/state/message'

import { initCallback } from 'Pages/MessageCheckupLinkCheck/recoil/callbacks/callbacks'

const MessageCheckupSummary = () => {
  const { id } = useParams()
  const intl = useIntl()
  const { loading, loaded, error } = useRecoilValue(pageState)
  const { links, showJustBadReputation, showJustUnreachable } = useRecoilValue(
    messageState
  )
  const { unreachableImgs } = useRecoilValue(linkcheckSummaryBoxState)
  const init = useRecoilCallback(initCallback, [])

  useEffect(() => {
    init(id)
  }, [])

  return (
    <>
      <Header />
      <Loading open={loading} />
      <PageContainer>
        {!error && loaded && (links.link.length > 0 || links.image.length > 0) && (
          <>
            <Flex columnGap='32px'>
              <FlexItem flex='1 0'>
                <CheckReputation />
              </FlexItem>
              <FlexItem flex='1 0'>
                <CheckReachability />
              </FlexItem>
            </Flex>
            <Flex display='block' margin='0 0 24px 0'>
              {links.link.length > 0 && <LinkSection sectionType='link' />}
              {(links.image.length > 0 &&
                !showJustBadReputation &&
                !showJustUnreachable) ||
              (showJustUnreachable && unreachableImgs.length > 0) ? (
                <>
                  <SpacingVertical variant={SPACING_24} />
                  <LinkSection sectionType='image' />
                </>
              ) : null}
            </Flex>

            <Footer />
          </>
        )}
        {!error &&
          loaded &&
          links.link.length === 0 &&
          links.image.length === 0 && (
            <>
              <EmptyState
                title={intl.formatMessage({
                  id: 'Load.EmailCheckUp.LinkCheckEmptyState'
                })}
                description={intl.formatMessage({
                  id: 'Load.EmailCheckUp.LinkCheckEmptyStateDescription'
                })}
              />
            </>
          )}
      </PageContainer>
    </>
  )
}

export default MessageCheckupSummary
